import { useEffect, useRef, useState } from 'react'

import './DemoSearchBar.scss'

import { type DemoSearchBarProps } from './types'

export const DemoSearchBar = ({
  searchQuery,
  onSearchChange,
  recentDemos,
  onSelectRecent,
  onCreateClick,
  showArchived,
  onShowArchivedChange,
}: DemoSearchBarProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(true)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current
        && !containerRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div className='demo-search-bar'>
      <div className='demo-search-bar__main'>
        <div ref={containerRef} className='demo-search-bar__container'>
          <input
            type='text'
            placeholder='Search demos by name...'
            value={searchQuery}
            onChange={e => onSearchChange(e.target.value)}
            onFocus={() => setIsDropdownOpen(true)}
            className='demo-search-bar__input'
            autoFocus
          />
          {isDropdownOpen && recentDemos.length > 0 && !searchQuery && (
            <div className='demo-search-bar__dropdown'>
              <div className='demo-search-bar__dropdown-header'>Recent Demos</div>
              {recentDemos.map(name => (
                <div
                  key={name}
                  className='demo-search-bar__dropdown-item'
                  onClick={() => {
                    onSelectRecent(name)
                    setIsDropdownOpen(false)
                  }}
                >
                  {name}
                </div>
              ))}
            </div>
          )}
        </div>
        <label className='demo-search-bar__archived-toggle'>
          <input
            type='checkbox'
            checked={showArchived}
            onChange={e => onShowArchivedChange(e.target.checked)}
          />
          Show archived
        </label>
      </div>
      <button className='demo-search-bar__create-button' onClick={onCreateClick}>
        + Create
      </button>
    </div>
  )
}
